import api from '@/api';

export default {
    //게시판의 모든 article 가져오기
    getTotalArticles(searchSet: article.TotalArticleSearchSet): Promise<article.PagedData<article.TotalArticle>> {
        return api.post<article.PagedData<article.TotalArticle>>({
            url: `/Portal/Article/api/getTotalArticles`,
            data: searchSet
        });
    },
    //article 가져오기
    getArticles(searchSet: article.SearchSet): Promise<article.PagedData<article.Article>> {
        return api.post<article.PagedData<article.Article>>({
            url: `/Portal/Article/api/getArticles`,
            data: searchSet
        });
    },
    //관리자 article 가져오기
    getAdminArticles(searchSet: article.SearchSet): Promise<article.PagedData<article.Article>> {
        return api.post<article.PagedData<article.Article>>({
            url: `/Portal/BoardAdmin/api/getArticles`,
            data: searchSet
        });
    },

    getWebpartArticles(searchSet: article.WebpartQuerySet): Promise<article.PagedData<article.WebpartArticle>> {
        return api.post<article.PagedData<article.WebpartArticle>>({
            url: `/Portal/Article/api/getWebpartArticles`,
            data: searchSet
        });
    },

    //글 작성
    createArticle(set: article.ArticleQuerySet): Promise<common.CreateResultSet> {
        return api.post<common.CreateResultSet>({
            url: `/Portal/Article/api/createArticle`,
            data: set
        })
    },
    //작성글 보기
    getArticleDetail(boardId: number, articleId: number): Promise<article.ArticleDetail> {
        return api.get<article.ArticleDetail>({
            url: `/Portal/Article/api/GetArticleDetail?boardId=${boardId}&articleId=${articleId}`,
        })
    },
    //게시글 이력 조회
    getArticleDetailHistory(boardId: number, articleId: number, articleVersion: number): Promise<article.ArticleDetail> {
        return api.get<article.ArticleDetail>({
            url: `/Portal/Article/api/GetArticleDetail?boardId=${boardId}&articleId=${articleId}&articleVersion=${articleVersion}`,
        })
    },
    //작성글 수정
    updateArticle(set: article.ArticleQuerySet): Promise<common.UpdateResultSet> {
        return api.post<common.UpdateResultSet>({
            url: `/Portal/Article/api/updateArticle`,
            data: set
        })
    },
    //작성글 삭제
    deleteArticle(set: article.DeleteArticle): Promise<number> {
        return api.post<number>({
            url: `/Portal/Article/api/deleteArticle`,
            data: set
        })
    },

    deleteArticles(set: article.DeleteArticleSet): Promise<number> {
        return api.post<number>({
            url: `/Portal/BoardAdmin/api/deleteArticles`,
            data: set
        })
    },

    restoreArticles(set: number[]): Promise<number> {
        return api.post<number>({
            url: `/Portal/BoardAdmin/api/restoreArticles`,
            data: set
        })
    },

    toggleArticlesSecret(set: number[]): Promise<number> {
        return api.post<number>({
            url: `/Portal/BoardAdmin/api/toggleArticlesSecret`,
            data: set
        })
    },
    //첨부파일 
    getArticleFile(fileCode: string): Promise<article.FileStore[]> {
        return api.get<article.FileStore[]>({
            url: `/File/Store/api/GetFilelist`,
            params: {
                code: fileCode
            }
        })
    },
    getArticleFileHistory(fileCode: string, articleVersion: number): Promise<article.FileStore[]> {
        return api.get<article.FileStore[]>({
            url: `/Portal/Article/api/articlefilehistory?fileCode=${fileCode}&articleVersion=${articleVersion}`
        })
    },
    //댓글 가져오기
    getArticleComments(set: article.CommentFetchSet): Promise<article.PagedData<article.ArticleComment>> {
        return api.post<article.PagedData<article.ArticleComment>>({
            url: `/Portal/Article/api/getComments`,
            data: set
        })
    },
    //조회수
    createViewLog(set: article.CreateOptionSet): Promise<article.ArticleDetail> {
        return api.post<article.ArticleDetail>({
            url: `/Portal/Article/api/createViewLog`,
            data: set
        })
    },
    //댓글 작성
    createComment(set: article.CreateComment): Promise<article.ArticleComment> {
        return api.post<article.ArticleComment>({
            url: `/Portal/Article/api/createComment`,
            data: set
        })
    },
    //댓글 삭제
    deleteComment(commentId: number): Promise<number> {
        return api.get<number>({
            url: `/Portal/Article/api/deleteComment?commentId=${commentId}`
        })
    },
    //추천수 +1
    createRecommend(set: article.CreateOptionSet): Promise<number> {
        return api.post<number>({
            url: `/Portal/Article/api/createRecommend`,
            data: set
        })
    },
    //추천수 -1
    deleteRecommend(set: article.DeleteRecommendSet): Promise<number> {
        return api.get<number>({
            url: `/Portal/Article/api/deleteRecommend?articleId=${set.articleId}&userCode=${set.userCode}`
        })
    },
    //추천인 리스트
    getRecommendList(articleId: number): Promise<article.RecommendSet[]> {
        return api.get<article.RecommendSet[]>({
            url: `/Portal/Article/api/recommends?articleId=${articleId}`
        })
    },
    //조회한 사용자 리스트
    getViewLogList(articleId: number): Promise<article.ViewLogSet[]> {
        return api.get<article.ViewLogSet[]>({
            url:`/Portal/Article/api/viewlogs?articleId=${articleId}`
        })
    },
    checkArticlePassword(set: article.PasswordCheckSet): Promise<boolean> {
        return api.post<boolean>({
            url: '/Portal/Article/api/checkPassword',
            data: set
        });
    },

    getArticleHistoryList(articleId: number): Promise<article.ArticleHistoryItem[]> {
        return api.get<article.ArticleHistoryItem[]>({
            url: `/Portal/Article/api/articlehistory?articleId=${articleId}`
        })
    },

    getSystemAuth(systemId: number): Promise<article.SystemAuth[]> {
        return api.get<article.SystemAuth[]>({
            url: '/Common/Menu/api/personsystemlist',
            params: {
                systemId: systemId
            }
        })
    },   

    // 예약 게시글 작성
    createReservedArticle(set: article.ArticleQuerySet): Promise<number> {
        return api.post<number>({
            url: `/Portal/Article/api/createReserve`,
            data: set
        })
    },

    // 예약 게시글 조회
    getReservedArticleDetail(boardId:number, articleId:number): Promise<article.Article>{
        return api.get({
            url: `/Portal/Article/api/reservedArticle?articleId=${articleId}&boardId=${boardId}`
        })

    },
    // 예약된 게시글 수정
    updateReservedArticle(set: article.ArticleQuerySet): Promise<number> {
        return api.post<number>({
            url: `/Portal/Article/api/updateReserve`,
            data: set
        })
    },
    // 예약 게시글 목록
    getReservedArticleList(boardId:number): Promise<article.Article[]>{
        return api.get({
            url: `/Portal/Article/api/reservedList?boardId=${boardId}`
        })
    },
    // 예약 게시글 선택 목록 삭제
    deleteReservedArticles(reservedIds:string): Promise<number> {
        return api.delete<number>({
            url: `/Portal/Article/api/deleteReserve?reservedIds=${reservedIds}`
        })
    },
    // 예약 게시글 선택 목록 게시
    postReservedArticles(reservedIds:string,boardId:number): Promise<number>{
        return api.post<number>({
            url: `/Portal/Article/api/postArticles?reservedIds=${reservedIds}&boardId=${boardId}`
        })
    },
    // 사용자 게시글 조회여부 조회
    getUserArticleViewlogs(viewlogSet: article.ArticleViewlogSet): Promise<number[]>{
        return api.post({
            url: `/Portal/Article/api/viewlogList`,
            data:viewlogSet
        })
    }
}